<script>
    import {onDestroy, onMount} from 'svelte';
    import {PRConnect} from "@projectroom/ui-lib";
    import {navigateTo} from 'svelte-router-spa';
    import {fade} from 'svelte/transition';
    import Select from 'svelte-select';
    import axios from "axios";

    class PageInfo {
        constructor({page=1, perPageNum=20, totalCount=100}) {
            this.totalCount = totalCount;
			this.perPageNum = perPageNum;
            this.setPage(page, perPageNum); 
        }

        setPage(page=1) {
            this.page = page;
            this.showPage = 10;
            this.pageStartNum = (page - 1) * this.perPageNum;
            this.endPage = Math.ceil(page / this.showPage) * this.showPage;
            this.startPage = this.endPage - this.showPage + 1;
            let tempEndPage = Math.ceil(this.totalCount / this.perPageNum);
            if ( this.endPage > tempEndPage) {
                this.endPage = tempEndPage;
            }
            this.prev = this.startPage != 1;
            this.next = this.endPage * this.perPageNum < this.totalCount; 
            this.pageList=[]; 
            for (let i = this.startPage; i <= this.endPage; i++) { 
                this.pageList.push(i);
            }
        }

        getListNumber(index) {
            return (this.page - 1) * this.perPageNum + index;
        }
        clickPrev() {
            this.setPage(this.page - 1);
            getAvatalkList();
        }
        clickNext() {
            this.setPage(this.page + 1);
            getAvatalkList();
        }
        clickPage(page) {
            this.setPage(page);
            getAvatalkList();
        }
        clickSearch() {
            this.setPage();
            getAvatalkList();
        }
        enter(e) {
            if (e.key === "Enter") {
                this.clickSearch();
            }
        }
    }

    let avatalkList = [];
    let options = { year: "numeric", month: "long", day: "numeric" };
	let searchText = '';
    let searchCondition;
    let isPhoneNoPopup = false;
    let pageInfo = new PageInfo({"perPageNum":10});
    let viewPhoneNo;
    let viewEmail;
    let viewName;
	let currentTab = "avatalkManage"
    
    const getAvatalkList = (e) => {
        PRConnect.send("/api/Admin/getAvatalkList", {...pageInfo, searchCondition, searchText}, data => {
            if (data.header.status === "success") {
                avatalkList = data.result.avatalkList;
                let totalCount = data.result.totalCount;
                pageInfo = new PageInfo({...pageInfo, totalCount});
            } 
		}, () => { navigateTo("/main"); });
    }

    const goToUserLogin = (avatalk) => {
        PRConnect.send("/api/Admin/setUserLogin", {userId :avatalk.userId}, data => {
            if (data.header.status === "success") {
                window.open(`/builder/${avatalk.id}`, "_blank");
            }
        });
    }

    const clickPhoneNo = (user) => {
        isPhoneNoPopup = true;
        viewEmail = user.emailId;
        viewPhoneNo = user.phoneNo;
        viewName = user.name;
    }

    onMount(() => {
        getAvatalkList();
    });

	const clickBlank = (pageUrl) => {
		window.open(pageUrl, "_blank");
	}

	const clickChangeOpenFlag = (avatalk) => {
		avatalk.creepongViewFlag = avatalk.creepongViewFlag === "Y" ? "N" : "Y";
		avatalkList = [...avatalkList];
		PRConnect.send("/api/Admin/modifyAvatalkOpenFlag", {botId : avatalk.id, creepongViewFlag : avatalk.creepongViewFlag}, data => {
            if (data.header.status === "success") {
                console.log("creepongViewFlag update");
            }
        });
	}
	
</script>

<div class="container home" in:fade>
	
	<div class="w-tab-content" in:fade>
		<div class="tabs-menu-4 w-tab-menu">
		<a data-w-tab="Tab 1" class="tab-link-tab-1-4 w-inline-block w-tab-link" class:w--current={currentTab == "defaultManage"} on:click={()=> currentTab = "defaultManage"}>
		<div class="text-block-139">기본설정 관리</div>
		</a>
		<a data-w-tab="Tab 2" class="tab-link-tab-2-4 w-inline-block w-tab-link" class:w--current={currentTab == "avatalkManage"} on:click={()=> currentTab = "avatalkManage"}>
		<div class="text-block-140">아바톡 관리</div>
		</a>
	</div>
		<div data-w-tab="Tab 1" class="w-tab-pane" class:w--tab-active={currentTab == "avatalkManage"}>
			<div class="title-wrapper">
				<div class="title-inner">
					<div class="title1">Home</div>
					<div class="title-main">아바톡목록</div>
					<div class="title-sub">생성되어 있는 아바톡 목록입니다.</div>
				</div>
			</div>
			<div class="userList-wrapper">
				<div class="search-wrapper">
					<select bind:value={searchCondition}>
						<option value="avatalkId" selected>아바톡 아이디</option>
						<option value="title">아바톡 이름</option>
						<option value="userId" selected>사용자 아이디</option>
						<option value="userEmail">사용자 이메일</option>
						<option value="userName">사용자 이름</option>
					</select>
					<input type="text" bind:value={searchText} on:keydown={(e)=> pageInfo.enter(e)}>
					<button on:click={getAvatalkList}>
						검색
					</button>
				</div>
				<div class="table-wrapper">
					<table>
						<tr class="tr-th">
							<th class="no">#</th>
							<th>아이디</th>
							<th class="table-name">이메일</th>
							<th class="table-name">이름</th>
							<th>아바톡아이디</th>
							<th>아바톡</th>
							<th>프로필</th>
							<th class="table-name">아바톡 이름</th>
							<th>크리퐁공개여부</th>
							<th>사용자로그인</th>
						</tr>
					{#each avatalkList as avatalk, index (index)}
						<tr>
							<td class="no">{pageInfo.getListNumber(index+1)}</td>
							<td>{avatalk.userId}</td>
							<td>{avatalk.userEmail}</td>
							<td>{avatalk.userName}</td>
							<td>{avatalk.id}</td>
							<td class="pointer" on:click={()=>clickBlank(avatalk.pageUrl)}>확인하기</td>
							<td><img src={avatalk.iconImageContent} width="40px" /></td>
							<td>{avatalk.title || ""}</td>
							<td >
								<div class="toggle-button _2" on:click={()=>clickChangeOpenFlag(avatalk)}>
									<div class="toggle" class:on={avatalk.creepongViewFlag === "Y"}></div>
									<div class="toggle-round" class:on={avatalk.creepongViewFlag === "Y"}></div>
								</div>
							</td>
							<td class="pointer" on:click={() => goToUserLogin(avatalk)}>빌더가기</td>
						</tr>
					{/each}
					</table>
				</div>
				<div class="paging-wrapper">
					{#if pageInfo.prev}
					<div class="page-number" on:click={()=> pageInfo.clickPrev()}>◀︎</div>
					{/if}
					{#each pageInfo.pageList as page} 
					<div class="page-number" class:active={pageInfo.page === page} on:click={() => pageInfo.clickPage(page)}>{page}</div>
					{/each}
					{#if pageInfo.next}
					<div class="page-number" on:click={()=> pageInfo.clickNext()}>▶︎</div>
					{/if}
				</div>
			</div>
		</div>
		<div data-w-tab="Tab 2" class="w-tab-pane" class:w--tab-active={currentTab == "defaultManage"}>
			<div class="">
			</div>
		</div>
	</div>
</div>
<div class="ava-popup" class:show={isPhoneNoPopup}>
    <div class="popup-layer withdraw">
        <div class="titile-text popup">
            <div class="h1 margin20">회원 정보</div>
            <div class="title-sub popup">{viewName} / {viewEmail}</div>
            <div class="title-sub popup view-phoneNo">{viewPhoneNo}</div>
        </div>
        <div class="popup-button">
            <a href="#" class="close-button w-button" on:click={()=>isPhoneNoPopup = false}>닫기</a>
        </div>
    </div>
</div>
<style>
    .userList-wrapper {
        margin: 0 auto;
        overflow: auto;
    	height: max-content;
    }
    .active {
        font-weight: bold;
    }
    .page-number {
        cursor: pointer;
        display: inline-block;
        padding: 12px;
    }
	.title-wrapper {
		padding-left: 10px;
		border: 1px solid transparent;
    	background-color: transparent;
	}
    td {
        padding: 12px;
        text-align: center;
    }
    td, th { 
        min-width: 100px;
    }
    .tr-th {
        border-bottom: 2px solid darkgray;
    }

	th.no {
		width: 50px;
	}

	td.no {
		width: 50px;
	}

    .table-email {
        min-width: 300px;
    }
    .table-name {
        min-width: 200px;
    }
    .paging-wrapper {
        display: flex;
        margin: 0 auto;
        width: max-content;
    }

    .search-wrapper {
        margin-bottom: 16px;
    }
    .popup-button {
        margin-top: 20px;
    }
    .view-phoneNo {
        font-size: 20px;
        font-weight: 700;
    }
	
	.toggle.on {
        border-color: #ff558d;
        border-radius: 30px;
        background-color: #ff558d;
    }

    .toggle {
        background-color: #999;
    }

	.container {
		overflow-x: auto;
		align-items: center;
	}
	.title-inner {
		margin-left: 0;
	}
	.w-tab-content {
		min-width: 1600px;
		margin-top: 10px;
	}
	.table-wrapper {
		overflow: scroll;
	}
</style>